// extracted by mini-css-extract-plugin
export default {"button":"TransactionDetailsDialog_button__Xlpli"};